import { render } from "./SignUp.vue?vue&type=template&id=67144205&scoped=true"
import script from "./SignUp.vue?vue&type=script&lang=js"
export * from "./SignUp.vue?vue&type=script&lang=js"

import "./SignUp.vue?vue&type=style&index=0&id=67144205&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-67144205"

export default script